import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
    Text,
    Avatar,
    Title,
    FilledIconButton,
    EditIcon,
    FileIcon,
    DeleteIcon,
    HorizontalRule,
    NoInformation,
    Tag,
    CheckCircleIcon,
    CrossCircleIcon,
} from '../../index';

const PatientList = ({ data, onDelete, prevTab }) => {
    const history = useHistory();
    const location = useLocation();

    const onEdit = (id) => {
        history.push({
            pathname: `/provider/client/${id}`,
            state: {
                prevPath: location.pathname,
                prevTab: prevTab,
            },
        });
    };

    const onDetail = (id) => {
        history.push({
            pathname: `/provider/client/detail/${id}`,
            state: {
                prevPath: location.pathname,
                prevTab: prevTab,
            },
        });
    };



    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                rowGap: '15px',
                minHeight: '450px',
            }}
        >
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: '48px 200px auto 100px 45%',
                    alignItems: 'center',
                    columnGap: '15px',
                }}
            >
                <div></div>
                <Text $bold>Name</Text>
                <Text $bold>ID</Text>
                <Text $bold>FRIDAY App</Text>
                <Text $bold>Diagnosis</Text>
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {data && data.length > 0 ? (
                    data.map((patient, index) => (
                        <div
                            key={patient.id}
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                rowGap: '6px',
                                marginBottom: data.length !== index + 1 ? '6px' : 0,
                            }}
                        >
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: '48px 200px auto 100px 45%',
                                    alignItems: 'center',
                                    columnGap: '15px',
                                }}
                            >
                                <Avatar
                                    alt={!patient?.user ? '' : patient?.user?.fullname}
                                    src={!patient?.user ? null : patient?.user?.avatar?.url}
                                    $avatarSize="48px"
                                    onClick={() => onDetail(patient.id)}
                                />
                                <Title
                                    style={{
                                        margin: '4px 0 8px',
                                        width: '200px',
                                        wordSpacing: '400px',
                                    }}
                                    $fontSize="16px"
                                    $ellipsis
                                    $lineHeight="20px"
                                >
                                    {!patient?.user ? 'Inactive' : patient?.user?.fullname}
                                </Title>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Text>{patient.HNCode ? patient.HNCode : ''}</Text>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {patient?.user?.uuid ? (
                                        <CheckCircleIcon fill="green9" />
                                    ) : (
                                        <CrossCircleIcon />
                                    )}
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    }}
                                >
                                    <div style={{ display: 'flex', columnGap: '10px' }}>
                                        {patient.patientTag?.slice(0, 2).map((tag) => (
                                            <Tag key={tag}>{tag}</Tag>
                                        ))}
                                    </div>
                                    <div>
                                        <FilledIconButton
                                            $width="24px"
                                            $height="24px"
                                            $backgroundColor="purple"
                                            onClick={() => onEdit(patient.id)}
                                        >
                                            <EditIcon />
                                        </FilledIconButton>
                                        <FilledIconButton
                                            $width="24px"
                                            $height="24px"
                                            onClick={() => onDetail(patient.id)}
                                        >
                                            <FileIcon />
                                        </FilledIconButton>
                                        {onDelete && (
                                            <FilledIconButton
                                                $width="24px"
                                                $height="24px"
                                                $backgroundColor="pink"
                                                onClick={() => onDelete(patient.id)}
                                            >
                                                <DeleteIcon />
                                            </FilledIconButton>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <HorizontalRule />
                        </div>
                    ))
                ) : (
                    <NoInformation />
                )}
            </div>
        </div>
    );
};

PatientList.propTypes = {
    searchValue: PropTypes.string,
    onDelete: PropTypes.func,
    data: PropTypes.arrayOf(PropTypes.object),
    prevTab: PropTypes.number,
};

export default PatientList;
